module.exports = __webpack_public_path__ + "static/media/clock.c51c98f0.svg";